import http from "../../shared/http"
import Vue from 'vue'
import { isEmpty, concat } from 'lodash'
import Component from '@/lib/Component'

const components = {
    state: {
        currentComponent: {},
        components: [],
        componentsMenu: [],
        componentsSettings: [],
        componentsModels: {},
        componentsDidSetup: false,
    },
    actions: {
        fetchComponentsMenu({commit}) {
            return new Promise((resolve, reject) => {
                http.get("/v3/system/component/menu").then((resp) => {
                    if (resp === undefined) {
                        reject(new Error("Unexpected error"));
                    }

                    commit('SET_COMPONENTS_MENU', resp.data)
                    resolve(resp.data)
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        fetchComponents({commit}) {
            return new Promise((resolve, reject) => {
                http.get("/v3/system/components").then((resp) => {
                    if (resp === undefined) {
                        reject(new Error("Unexpected error"));
                    }

                    const d = resp.data.map(c => (new Component(c)))

                    commit('SET_COMPONENTS', d)
                    resolve(d)
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        async fetchComponentsSettings({commit, getters}, ref) {
            const settings = getters.componentSettings(ref)
            if (settings) return settings

            const { data } = await http.get(`/v3/system/component/settings/${ref}`)
            const d = {
                general: new Component(data.general),
                settings: data.settings,
                workspaces: data.workspaces,
            }

            commit('SET_COMPONENTS_SETTINGS', d)

            return d
        },

        updateComponentSettings({commit}, settings) {
            return new Promise((resolve, reject) => {
                console.log("UPDATE COMPONENT SETTINGS", settings)
                
                http.post("/v3/system/component/settings/" + settings.general.uuid + "/" + settings.settings.version, settings).then(() => {
                    commit("SET_COMPONENTS_SETTINGS", settings)

                    resolve(settings)
                }).catch(error => {
                    console.log(error)
                    reject(error)
                })
            })
        },

        fetchComponentsModels(self, payload) {
            return new Promise((resolve, reject) => {
                let ctx = payload.context

                let offset = ctx.currentPage
                if (offset == undefined) {
                    offset = 0
                }

                let limit = ctx.perPage
                if (limit == undefined || limit == -1) {
                    limit = 10
                    if (payload.isApp) {
                        limit = 500
                    }
                }

                let sortDesc = 1
                if (ctx.sortDesc) {
                    sortDesc = -1
                }

                if (ctx.filterOn === undefined) {
                    ctx.filterOn = []
                }

                let params =  {
                    offset: offset,
                    sortBy: ctx.sortBy,
                    sortDesc: sortDesc,
                    filter: ctx.filter,
                    filterOn: ctx.filterOn.join(","),
                    disabled: ctx.disabled,
                    limit: limit,
                    dateFrom: ctx.dateFrom,
                    dateTo: ctx.dateTo,
                    dateField: ctx.dateField
                }
                
                if (!isEmpty(ctx.$adv)) {
                    params.$adv = JSON.stringify([ctx.$adv])
                }

                if (!isEmpty(ctx.$aggregate)) {
                    params.$aggregate = JSON.stringify(ctx.$aggregate)
                }

                let source = ''
                if (payload.isApp) {
                    source = 'platform-app'
                }
 
                this._vm.$component(payload.uuid).store().models(params, {
                    app: payload.isApp,
                    cache: payload.cache,
                    buildTTL: payload.buildTTL,
                    source: source
                }).then((resp) => {
                    let { data = []} = resp || {}

                    resolve(data)
                }).catch((err) => {
                    console.log(err)
                    reject(err)
                })
            })
        },

        fetchRelationModels({dispatch}, payload) {
            return dispatch('fetchComponentsModels', payload)
        },

        componentsDidSetup({commit}) {
            commit('COMPONENTS_DID_SETUP', true)
        },

        componentPublicVersion({commit}, version) {
            commit('SET_PUBLIC_VERSION', version)
        },

        componentDevVersion({commit}, version) {
            commit('SET_DEV_VERSION', version)
        }
    },
    mutations: {
        SET_PUBLIC_VERSION (state, version) {
            state.currentComponent.public_version = version
        },

        SET_DEV_VERSION (state, version) {
            state.currentComponent.dev_version = version
        },

        SET_COMPONENTS_MENU (state, menu) {
            state.componentsMenu = menu
        },

        SET_COMPONENTS (state, components) {
            state.components = components
        },

        UPDATE_COMPONENTS_MENU_ICON(state, payload) {
            state.componentsMenu.map(i => {
                if (i.uuid == payload.uuid) {
                    i.icon = payload.icon
                }
            })
        },

        UPDATE_COMPONENTS_MENU_ACTIVE(state, payload) {
            state.componentsMenu.map(i => {
                if (i.uuid == payload.uuid) {
                    i.is_active = payload.is_active
                }
            })
        },

        UPDATE_COMPONENTS_MENU_SORT(state, payload) {
            state.componentsMenu.map(i => {
                if (i.uuid == payload.uuid) {
                    i.sort = payload.sort
                }
            })
        },

        SET_COMPONENTS_MODELS(state, payload) {
            console.log("SET_COMPONENTS_MODELS", state.componentsModels[payload.uuid])
            if (state.componentsModels[payload.uuid] === undefined) {
                state.componentsModels[payload.uuid] = payload.results;
            } else {
                state.componentsModels[payload.uuid] = concat(state.componentsModels[payload.uuid], payload.results);
            }
        },

        PATCH_COMPONENT_MODEL(state, payload) {
            let repo = state.componentsModels[payload.uuid];

            if (repo === undefined) {
                return
            }

            repo.map(m => {
                if (m.uuid == payload.result.uuid) {
                    let keys = Object.keys(payload.result)

                    keys.forEach(k => {
                        if (m[k] != "uuid") {
                            m[k] = payload.result[k]
                        }
                    })
                }
            })

            state.componentsModels[payload.uuid] = repo
        },
        
        SET_COMPONENTS_MODEL(state, payload) {
            let repo = state.componentsModels[payload.uuid];

            if (repo === undefined) {
                return
            }

            let found = repo.find(m => {
                return m.uuid == payload.results.uuid
            })

            if (found !== undefined) {
                let r = repo.map(m => {
                    if (m.uuid == payload.results.uuid) {
                        return payload.results
                    } else {
                        return m
                    }
                })

                state.componentsModels[payload.uuid] = r
            } else {
                repo.push(payload.results);
            }
        },

        REMOVE_COMPONENTS_MODEL(state, payload) {
            let repo = state.componentsModels[payload.uuid];

            if (repo !== undefined) {
                state.componentsModels[payload.uuid] = repo.filter(m => {
                    return m.uuid !== payload.model_uuid
                })
            }
        },

        SET_COMPONENTS_SETTINGS (state, settings) {
            let updated = 0

            settings.general = new Component(settings.general)

            state.componentsSettings.forEach((value, index) => {
                if (value.general.uuid == settings.general.uuid) {
                    //state.componentsSettings[index] = settings;
                    Vue.set(state.componentsSettings, index, settings)
                    updated = 1;
                    return
                }
            })
            
            if (!updated) {
                state.componentsSettings.push(settings)
            }
        },
        SET_COMPONENTS_MODELS_LIST (state, {uuid, data}) {
            state.componentsModelsList[uuid] = data
        },

        SET_CURRENT_COMPONENT (state, uuid) {
            if (typeof uuid == 'string') {
                state.currentComponent = state.componentsMenu.find(el => {
                    return el.uuid == uuid
                })
            } else {
                state.currentComponent = uuid
            }
        },

        REMOVE_COMPONENT (state, uuid) {
            state.componentsMenu = state.componentsMenu.filter(c => {
                return c.uuid != uuid;
            }) 

            state.componentsSettings = state.componentsSettings.filter(c => {
                return c.general.uuid != uuid;
            })
        },

        COMPONENTS_DID_SETUP (state, condition) {
            state.componentsDidSetup = condition
        }
    },
    getters: {
        componentsMenu(state) {
            return state.componentsMenu.filter(m => {
                return m.workspaces.find(w => {
                    return w.workspace_uuid == localStorage.getItem("current_workspace_uuid")
                }) !== undefined
            })
        },

        componentsMenuSettings(state, getters) {
            let permissions = getters.permissions

            return state.componentsMenu.filter(c => {
                return permissions.find(permission => {
                    return permission.toLowerCase() == "settings " + c.name.toLowerCase()
                })
            })
        },

        componentSettings: (state) => (ref) => {
            return state.componentsSettings.find(value => {
                return value.general.getRef() == ref
            })
        },

        currentComponentSettings(state) {
            return state.componentsSettings.find(value => {
                return value.general.uuid == state.currentComponent.uuid
            })
        },

        currentComponent(state) {
            return state.currentComponent
        },

        componentModels: (state) => (uuid) => {
            return state.componentsModels[uuid] || []
        },

        componentModel: (state) => (cuuid, muuid) => {
            if (state.componentsModels[cuuid] !== undefined) {
                return state.componentsModels[cuuid].find(v => {
                    return v.uuid == muuid
                })
            }
            
            return null
        },

        componentDefaultVersion(state) {
            if (localStorage.getItem("current_env") == "dev") {
                return state.currentComponent.dev_version
            }

            if (localStorage.getItem("current_env") == "live") {
                return state.currentComponent.public_version
            }

            return "dev"
        },

        componentLiveVersion(state) {
            return state.currentComponent.public_version
        },

        components(state) {
            return state.components
        }
    }
  }

export default components;